import { VueConstructor } from 'vue';
import VueGtm from 'vue-gtm';
import VueI18n, { IVueI18n } from 'vue-i18n';
import { config } from './conf';
import i18nMessages from './lang';
import { VueRouter } from 'vue-router/types/router';
// used for declaration merging
import 'vuex';

export type VueI18nCustom = VueI18n & IVueI18n;
export type ValueOf<T> = T[keyof T];

export interface IODPluginsInstances {
  i18n: VueI18nCustom;
}

export interface IODGtmConfig {
  id: string;
  enabled: boolean;
  debug: boolean;
  loadScript?: boolean;
  vueRouter?: VueRouter;
  ignoredViews?: string[];
  queryParams?: {
    gtm_auth: string;
    gtm_preview: string;
    gtm_cookies_win: string;
  };
}

export interface IODComponentsCoreOptions {
  gtmConfig?: IODGtmConfig;
  pluginsInstances: IODPluginsInstances;
}

export default async function ODComponentsCore(vue: VueConstructor, options: IODComponentsCoreOptions): Promise<void> {
  if (options.gtmConfig) {
    vue.use(VueGtm, options.gtmConfig);
  }

  // we merge the translations
  Object.entries(i18nMessages).map(([locale, values]) =>
    options.pluginsInstances.i18n.mergeLocaleMessage(locale, values),
  );
}

export * from './components/WLFixAppointment/interfaces';
export * from './components/WLFixAppointment/utils';
export * from './components/WLProduct/types';
export * from './mixins';
export * from './store';
export * from './utils/productHelper';
export * from './utils/voucherHelper';
export * from './utils/enum';
